export const LINE_STATUS = {
  marche: { label: "En marche", dot: "bg-emerald-500", pulse: true, text: "text-emerald-400", badge: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30", stripe: "bg-emerald-500" },
  arret_non_planifie: { label: "Arrêt non planifié", dot: "bg-red-500", pulse: true, text: "text-red-400", badge: "bg-red-500/15 text-red-400 border-red-500/40", stripe: "bg-red-500" },
  arret_planifie: { label: "Arrêt planifié", dot: "bg-amber-500", text: "text-amber-400", badge: "bg-amber-500/15 text-amber-400 border-amber-500/30", stripe: "bg-amber-500" },
  pause: { label: "Pause", dot: "bg-sky-400", text: "text-sky-400", badge: "bg-sky-500/15 text-sky-400 border-sky-500/30", stripe: "bg-sky-400" },
  sans_of: { label: "Sans OF actif", dot: "bg-slate-500", text: "text-slate-400", badge: "bg-slate-500/15 text-slate-400 border-slate-600/30", stripe: "bg-slate-600" },
  hors_service: { label: "Hors service", dot: "bg-zinc-600", text: "text-zinc-500", badge: "bg-zinc-800 text-zinc-400 border-zinc-700/40", stripe: "bg-zinc-700" },
};

export const OF_STATUS = {
  prevu: { label: "Prévu", badge: "bg-slate-500/15 text-slate-300 border-slate-600/40" },
  en_production: { label: "En production", badge: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  arret: { label: "En arrêt", badge: "bg-red-500/15 text-red-400 border-red-500/40" },
  pause: { label: "Pause", badge: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  cloture: { label: "Clôturé", badge: "bg-zinc-700/40 text-zinc-300 border-zinc-600/40" },
  annule: { label: "Annulé", badge: "bg-zinc-800 text-zinc-500 border-zinc-700/40 line-through" },
  ouvert: { label: "Ouvert", badge: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
};

export const PRIORITY = {
  critique: { label: "Critique", badge: "bg-red-500/20 text-red-300 border-red-500/50" },
  elevee: { label: "Élevée", badge: "bg-amber-500/20 text-amber-300 border-amber-500/40" },
  moyenne: { label: "Moyenne", badge: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  urgente: { label: "Urgente", badge: "bg-red-500/20 text-red-300 border-red-500/50" },
  haute: { label: "Haute", badge: "bg-amber-500/20 text-amber-300 border-amber-500/40" },
  normale: { label: "Normale", badge: "bg-slate-500/15 text-slate-300 border-slate-600/40" },
  faible: { label: "Faible", badge: "bg-zinc-800 text-zinc-400 border-zinc-700/40" },
};

export const ALERT_LEVEL = {
  rouge: { label: "Critique", text: "text-red-400", stripe: "bg-red-500", badge: "bg-red-500/15 text-red-300 border-red-500/40" },
  orange: { label: "Vigilance", text: "text-amber-400", stripe: "bg-amber-500", badge: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
};
